import { render, staticRenderFns } from "./healthyDialog.vue?vue&type=template&id=1792eda5&scoped=true"
import script from "./healthyDialog.vue?vue&type=script&lang=js"
export * from "./healthyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792eda5",
  null
  
)

export default component.exports